import { render } from "./AddPlayerToFreebet.vue?vue&type=template&id=f9e38f6e"
import script from "./AddPlayerToFreebet.vue?vue&type=script&lang=js"
export * from "./AddPlayerToFreebet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__